import React, {Component} from 'react';
import {PostData} from '../services/PostData';
import {GetData} from '../services/GetData';
import {
  Row,
  Col,
  Button,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  FormGroup,
  Label,
  Input,
  InputGroup,
  Table
} from 'reactstrap';
import $ from 'jquery';
import QuestionPage from '../views/QuestionPage/';
import Pagination from "react-js-pagination";
import Sanitize from '../Sanitize';

class ExamSetup extends Component {
	
	constructor(props){
		super(props);
		this.state = {
            acyear : '',
            accyear : [],
			_message : '',
            alertClass :'',
            editId : '',
            totalmark : '',
            posts : [],
            subject :[],
            questions : [],
            sections: [],
            btnEditText : 'Update',
            btnText : 'Save',
			isview : false,
            _redirect : false,
            conducted : [],
            data : [],
            data1 : [],
            fsubject : [],
            sssubject : [],
            collapse: false,
            editcollapse: false,
            currentPage: 1,
			todosPerPage: 10,
            activePage : 1,
            fclass : ''
        }
		this.onChange = this.onChange.bind(this);
		this.onClsChange = this.onClsChange.bind(this);
		this.onSubChange = this.onSubChange.bind(this);
        this.onQusChange = this.onQusChange.bind(this);
        this.onMarkChange = this.onMarkChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.toggleCollapse = this.toggleCollapse.bind(this);
		this.onUpdateSubmit = this.onUpdateSubmit.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
    }

    onMarkChange(e){
        this.state.noofmark = e.target.value;
        var val = this.state.noofquestions * (e.target.value);
        this.state.totalmark = val;
        $("#totalMark").text(val);
        this.setState({noofmark : e.target.value});
    }

    handlePageChange(pageNumber) {
		
		this.setState({activePage: pageNumber});
		this.state.currentPage = Number(pageNumber);
	}

    toggleCollapse() {
		
		this.setState({collapse: !this.state.collapse,editcollapse : false});
    }
    
    filterClass(e){
        this.state.fclass = e.target.value;
        var d = this.state.data1;
        $("#fsub").val('');
        if(e.target.value!=''){
            var dat = d.filter(function(obj){
                return(obj.class == e.target.value);
            });
            this.setState({data : dat,activePage : 1,currentPage : 1});
            this.getsub();
        }
        else{
            this.setState({data : d,activePage : 1,currentPage : 1});
        }
    }

    filterSubject(e){
        this.state.fsub = e.target.value;
        var fclass = this.state.fclass;
        var d = this.state.data1;
        if(e.target.value!=''){
            var dat = d.filter(function(obj){
                return(obj.class == fclass && obj.subject == e.target.value);
            });
            this.setState({data : dat,activePage : 1,currentPage : 1});
        }
        else{
            this.setState({data : d,activePage : 1,currentPage : 1});
        }
    }

    getsub(){
		
        $("#showLoader").show();
        if(this.state.userRole == 'admin'){
            GetData('assignsubject/getsubbycls/'+this.state.acyear+'/'+this.state.fclass).then((result) => {
                $("#showLoader").hide();
                let responseJson = result;
                if(responseJson){
                    this.setState({
                        fsubject : responseJson
                    });
                }
            });
        }else if(this.state.userRole == 'questionbank'){
			GetData('assignsubject/getsubbystaff/'+this.state.acyear+'/'+this.state.fclass+'/'+this.state.staffid).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson){
					this.setState({
						fsubject : responseJson
					});
				}
			});
		}
	}

    onClsChange(e){
        $("#sub").val('');
        this.state.cls = e.target.value;
        this.setState({cls : e.target.value});
        var str = $("#clas").find(":selected").attr("data-name");
        this.state.clsname = str.includes("KG") ? str : str.substr(4,10);
		this.setState({[e.target.name]:e.target.value,isview : false});
		this.getsubject();
		this.getsection();
	}

    onSubChange(e){
        this.state.sub = e.target.value;
        this.state.subname = $("#sub").find(":selected").attr("data-name");
        this.setState({sub : e.target.value});
        this.getQuestion();
        this.getstaff();
    }
    
    onQusChange(e){
        this.state.question = e.target.value;
        this.setState({question : e.target.value});
        this.state.noofquestions = $("#question").find(":selected").attr("data-count");
        $("#totalMark").text('');
    }

    addzero(day) {
		var temp = '' + day;
		if (temp.length == 1) {

			temp = "0" + temp;
			return temp;
		}
		else {

			return temp;
		}

	}
    
    onUpdate(id){
        this.state.editId = id;
		var dat = this.state.data.filter(function(obj){
			return (obj.id == id);
        });
        this.state.acyear = dat[0]['acyear'];
        this.state.cls = dat[0]['class'];
        this.state.sec = dat[0]['section'];
        this.state.sub = dat[0]['subject'];
        this.state.question = dat[0]['question'];
        this.state.noofmark = dat[0]['noofmarks'];
        this.getQuestion();
        this.getsubject();
        this.getsection();
        this.getstaff();
        var from  = new Date(dat[0]['examfrom']);
        var to  = new Date(dat[0]['examto']);
        this.setState({
            examname : dat[0]['examname'],
            conductby : dat[0]['conductby'],
            orderby : dat[0]['orderby'],
            examdate : dat[0]['examdate'],
            fromtime : this.addzero(from.getHours())+':'+this.addzero(from.getMinutes()),
            totime : this.addzero(to.getHours())+':'+this.addzero(to.getMinutes()),
            reminder : dat[0]['reminder'],
            editcollapse : true,
            collapse : false
        });
    }
    
    componentWillMount(){
        this.getacyear();
        this.getclass();
    }
    
    getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
                $('#year option').eq(index + 1).prop('selected', true).trigger('change');
                this.getssubject();
                this.getExamSetup();
			}
		});
	}

    getssubject(){
		
		var ac = $("#year").val();
        if(this.state.userRole == 'questionbank'){
			$("#showLoader").show();
			GetData('assignsubject/getsubbystaffid/'+ac+'/'+this.state.staffid).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson){
					this.setState({
						sssubject : responseJson
					});
				}
			});
		}
	}

    /** get Class **/
	getclass(){
		
		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
    
    getsection() {
        var ar = $("#year").val();
        $("#showLoader").show();
        GetData('section/getsecbyclass/' + ar + '/' + this.state.cls).then((result) => {
            $("#showLoader").hide();
            let responseJson = result;
            if (responseJson) {
                this.setState({
                    sections: responseJson
                });
            }
        });
    }

    getstaff(){
        var ar = $("#year").val();
        $("#showLoader").show();
        GetData('question/getconductedstaff/' + ar + '/' + this.state.cls+'/'+this.state.sec+'/'+this.state.sub).then((result) => {
            $("#showLoader").hide();
            let responseJson = result;
            if (responseJson) {
                this.setState({
                    conducted: responseJson
                });
            }
        });
    }

    checkSubject(subid){
		var d = this.state.sssubject;
		var index = d.findIndex(function(obj){
			return(obj.subject == subid);
		});
		if(index != -1){
			return true;
		}else{
			return false;
		}
    }
    
    getExamSetup(){
		var ac = $("#year").val();
		$("#showLoader").show();
		GetData('question/getexamsetup/'+ac).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				
                var dat = [];
                if(this.state.userRole == 'questionbank'){
                    for(var i=0;i<responseJson.length;i++){
                        if(this.checkSubject(responseJson[i].subject)){
                            dat.push(responseJson[i]);
                        }
                    }
                }
                else{
                    dat = responseJson;
                }
                this.setState({
                    data : dat,
                    data1 : dat
                });
			}
		});
    }
    
	/** set value **/
	onChange(e){
        this.setState({[e.target.name]:e.target.value});
    }
    
    onUpdateSubmit(e){
        e.preventDefault();
        $("#showLoader").show();
		this.setState({btnText : 'Saving...'})
        PostData('question/editexamsetup',this.state).then((result) => {
            let responseJson = result;
            if(responseJson.status == '1' ){
                document.getElementById("editqus").reset();
                this.setState({
                    _message:'Exam Setup Updated Successfully!..',
                    alertClass:'alert alert-success',
                    btnText : 'Save',
                    questions : [],subject : [],sections : [],editcollapse : false
                });
                this.getExamSetup();
            }
            else{
        
                this.setState({
                    _message:'Invalid Key',
                    alertClass:'alert alert-danger',
                    btnText : 'Save'
                });
            }
            $("#showLoader").hide();
        });
    }
	
	/** submit form **/
	onSubmit(e){
        e.preventDefault();
        $("#showLoader").show();
		this.setState({btnText : 'Saving...'})
        PostData('question/examsetup',this.state).then((result) => {
            let responseJson = result;
            if(responseJson.status == '1' ){
                this.setState({
                    _message:'Exam Setup Added Successfully!..',
                    alertClass:'alert alert-success',
                    btnText : 'Save',
                    questions : [],subject : [],sections : [],
                });
                document.getElementById("addqus").reset();
                this.getExamSetup();
            }
            else{
        
                this.setState({
                    _message:'Invalid Key',
                    alertClass:'alert alert-danger',
                    btnText : 'Save'
                });
            }
            $("#showLoader").hide();
        });
	}
    
    getsubject(){
		
		var ac = $("#year").val();
		var cls = $("#clas").val();
        $("#showLoader").show();
        if(this.state.userRole == 'admin'){
            GetData('assignsubject/getsubbycls/'+this.state.acyear+'/'+this.state.cls).then((result) => {
                $("#showLoader").hide();
                let responseJson = result;
                if(responseJson){
                    this.setState({
                        subject : responseJson
                    });
                }
            });
        }
        else if(this.state.userRole == 'questionbank'){
			GetData('assignsubject/getsubbystaff/'+this.state.acyear+'/'+this.state.cls+'/'+this.state.staffid).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson){
					this.setState({
						subject : responseJson
					});
				}
			});
		}
	}
    
    getQuestion(){
        $("#showLoader").show();
		GetData('question/getquestionsetupbysub/'+this.state.acyear+'/'+this.state.cls+'/'+this.state.sub).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					questions: responseJson
                });
                if( this.state.editId!=''){
                    var qid = this.state.question;
                    var index = responseJson.findIndex(function(obj){
                        return(obj.questionid == qid);
                    });
                    
                    if(index > -1){
                        this.state.noofquestions = responseJson[index].noofquestions;
                        var val = this.state.noofquestions * this.state.noofmark;
                        this.state.totalmark = val;
                    }
                }
			}
		});
    }

    checkExam(exam){
        var bstate = false;
        var today = new Date().getTime();
        var exam = new Date(exam).getTime();
        if(exam < today){
            bstate = true;
        }
        return bstate;
    }

    render() {
     
    var items = this.state.posts;
    var acyear = this.state.accyear;

    let userData = JSON.parse(sessionStorage.getItem('userData'));
    this.state.userId = userData['userid'];
    this.state.userRole = userData['userrole'];
	this.state.staffid = userData['staffid'];
    
    // Logic for displaying current todos
	const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
	const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
	const currentTodos = this.state.data.slice(indexOfFirstTodo, indexOfLastTodo);

	const renderTodos = currentTodos.map((item,i) => {
		
		return <tr>
            <td>{indexOfFirstTodo+i+1}</td>
            <td>{item.examname}</td>
            <td>{item.clsname} - {item.secname}</td>
            <td>{item.subname}</td>
            <td>{item.questionname}</td>
            <td>{item.noofmarks}</td>
            <td>{parseFloat(item.totalmarks)}</td>
            <td>{item.timelimit}</td>
            <td>{Sanitize.dmyDash(item.examdate)}</td>
            <td>{item.fromtime} to {item.totime}</td>
            <td style={{textTransform : 'capitalize'}}>{item.reminder}</td>
            <td>
                <button name="editacyear" className="btn btn-info btn-sm" disabled={this.checkExam(item.examfrom)} onClick={() => this.onUpdate(item.id)} data-toggle="tooltip" data-placement="top" title="Edit"><i className="fa fa-edit"></i></button>
            </td>
        </tr>;
	});
    
    return (<div>
        <QuestionPage />
        <div className="animated fadeIn">
            <Row>
                <Col md="12">
                <div className={this.state.alertClass}>
                    {this.state._message}
                </div>
                <Card>
                    <CardHeader>
                        <strong>Exam Setup</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Academic Year : &nbsp;&nbsp;
                        <select name="acyear" onChange={this.onacChange} required id="year">
                            <option value="">Select</option>
                            {
                                acyear.map(function (item) {
                                    return <option value={item.id }>{item.value}</option>;
                                })
                            }
                        </select>&emsp;&emsp;
                        <select name="fclass" onChange={this.filterClass.bind(this)} required > 
                            <option value="">Filter by Class</option>
                            {
                                items.map(function (item) {
                                    return <option value={item.id}>{item.class}</option>;
                                })
                            }
                        </select>&emsp;&emsp;
                        {this.state.fclass!='' ?
                        <select name="fsub" id="fsub" onChange={this.filterSubject.bind(this)} required > 
                            <option value="">Filter by Subject</option>
                            {
                                this.state.fsubject.map(function (item) {
                                    return <option value={item.subject} data-name={item.prefix}>{item.sub}</option>;
                                })
                            }
                        </select> : ''}
                        <button className="btn btn-primary" style={{float : 'right'}} onClick={this.toggleCollapse}>Add Exam</button>
                    </CardHeader>
                    <CardBody id="asubbody">
                        
                        <Collapse isOpen={this.state.collapse} >
                            <form action="" method="post" role="form" id="addqus" encType="multipart/form-data" onSubmit={this.onSubmit} >
                            <Row>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Exam Name<span className="text-danger">*</span></Label>
                                        <Input type="text" name="examname" id="examname" onChange={this.onChange} required />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Class <span className="text-danger">*</span></Label>
                                        <select name="cls" onChange={this.onClsChange} id="clas" className="form-control" required > 
                                            <option value="">Select Class</option>
                                            {
                                                items.map(function (item) {
                                                    return <option value={item.id} data-name={item.class}>{item.class}</option>;
                                                })
                                            }
                                        </select>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Section <span className="text-danger">*</span></Label>
                                        <select name="sec" onChange={this.onChange} id="sec" className="form-control" required > 
                                            <option value="">Select Section</option>
                                            {this.state.sections.map(function (item) {
                                                return <option value={item.id} data-name={item.secs}>{item.secs}</option>;
                                            })}
                                        </select>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Subject <span className="text-danger">*</span></Label>
                                        <select name="sub" onChange={this.onSubChange} id="sub" className="form-control" required > 
                                            <option value="">Select Subject</option>
                                            {
                                                this.state.subject.map(function (item) {
                                                    return <option value={item.subject} data-name={item.prefix}>{item.sub}</option>;
                                                })
                                            }
                                        </select>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Conducted by <span className="text-danger">*</span></Label>
                                        <select name="conductby" className="form-control" onChange={this.onChange} required>
                                            <option value="">Select</option>
                                            {
                                                this.state.conducted.map(function (item,i) {
                                                    return <option value={item.id}>{item.empname} ({i == 0 ? 'Principal' : i==1 ? 'Class Teacher' : i==2 ? 'Subject Teacher' : ''})</option>;
                                                })
                                            }
                                        </select>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Question <span className="text-danger">*</span></Label>
                                        <select name="question" onChange={this.onQusChange} id="question" className="form-control" required > 
                                            <option value="">Select Question</option>
                                            {
                                                this.state.questions.map(function (item) {
                                                    return <option value={item.questionid} data-count={item.noofquestions}>{item.questionname}</option>;
                                                })
                                            }
                                        </select>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label style={{width : '100%'}}>No.of Mark (per question) <span className="text-danger">*</span> <span style={{float:'right'}}>Total</span></Label>
                                        <InputGroup>
                                            <Input type="text" name="noofmark" id="noofmark" onChange={this.onMarkChange} required />
                                            <div className="input-group-append">
                                                <div className="input-group-text" id="totalMark" style={{width : '60px'}}></div>
                                            </div>
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Order By <span className="text-danger">*</span></Label>
                                        <select name="orderby" className="form-control" onChange={this.onChange} required>
                                            <option value="">Select</option>
                                            <option value="random">Random</option>
                                            <option value="static">Static</option>
                                        </select>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Exam Date <span className="text-danger">*</span></Label>
                                        <Input type="date" name="examdate" id="examdate" onChange={this.onChange} required />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>From Time <span className="text-danger">*</span></Label>
                                        <Input type="time" name="fromtime" id="fromtime" onChange={this.onChange} required />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>To Time <span className="text-danger">*</span></Label>
                                        <Input type="time" name="totime" id="totime" onChange={this.onChange} required />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Reminder <span className="text-danger">*</span></Label>
                                        <select name="reminder" className="form-control" onChange={this.onChange} required>
                                            <option value="">Select</option>
                                            <option value="no-reminder">No-Reminder</option>
                                            <option value="sms">Sms</option>
                                            <option value="push">Push</option>
                                            <option value="sms & push">Sms & Push</option>
                                        </select> 
                                    </FormGroup>  
                                </Col>
                                <Col md={12}>
                                    <FormGroup>
                                        <Button type="submit" color="success" style={{float : 'right'}} disabled={this.state.btnText == 'Save' ? false : true}>{this.state.btnText}</Button>&emsp;
                                    </FormGroup>
                                </Col>
                            </Row>
                            </form>
                        </Collapse>
                        <Collapse isOpen={this.state.editcollapse} >
                            <form action="" method="post" role="form" id="editqus" encType="multipart/form-data" onSubmit={this.onUpdateSubmit} >
                            <Row>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Exam Name<span className="text-danger">*</span></Label>
                                        <Input type="text" name="examname" id="examname" onChange={this.onChange} value={this.state.examname} required />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Class <span className="text-danger">*</span></Label>
                                        <select name="cls" onChange={this.onClsChange} id="clas" className="form-control" value={this.state.cls} required > 
                                            <option value="">Select Class</option>
                                            {
                                                items.map(function (item) {
                                                    return <option value={item.id} data-name={item.class}>{item.class}</option>;
                                                })
                                            }
                                        </select>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Section <span className="text-danger">*</span></Label>
                                        <select name="sec" onChange={this.onChange} id="sec" className="form-control" value={this.state.sec} required > 
                                            <option value="">Select Section</option>
                                            {this.state.sections.map(function (item) {
                                                return <option value={item.id} data-name={item.secs}>{item.secs}</option>;
                                            })}
                                        </select>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Subject <span className="text-danger">*</span></Label>
                                        <select name="sub" onChange={this.onSubChange} id="sub" className="form-control" value={this.state.sub} required > 
                                            <option value="">Select Subject</option>
                                            {
                                                this.state.subject.map(function (item) {
                                                    return <option value={item.subject} data-name={item.prefix}>{item.sub}</option>;
                                                })
                                            }
                                        </select>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Conducted by <span className="text-danger">*</span></Label>
                                        <select name="conductby" className="form-control" onChange={this.onChange} value={this.state.conductby} required>
                                            <option value="">Select</option>
                                            {
                                                this.state.conducted.map(function (item,i) {
                                                    return <option value={item.id}>{item.empname} ({i == 0 ? 'Principal' : i==1 ? 'Class Teacher' : i==2 ? 'Subject Teacher' : ''})</option>;
                                                })
                                            }
                                        </select>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Question <span className="text-danger">*</span></Label>
                                        <select name="question" onChange={this.onQusChange} id="question" className="form-control" value={this.state.question} required > 
                                            <option value="">Select Question</option>
                                            {
                                                this.state.questions.map(function (item) {
                                                    return <option value={item.questionid} data-count={item.noofquestions}>{item.questionname}</option>;
                                                })
                                            }
                                        </select>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label style={{width : '100%'}}>No.of Mark (per question) <span className="text-danger">*</span> <span style={{float:'right'}}>Total</span></Label>
                                        <InputGroup>
                                            <Input type="text" name="noofmark" id="noofmark" onChange={this.onMarkChange} value={this.state.noofmark} required />
                                            <div className="input-group-append">
                                                <div className="input-group-text" style={{width : '60px'}}>{this.state.totalmark}</div>
                                            </div>
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Order By <span className="text-danger">*</span></Label>
                                        <select name="orderby" className="form-control" onChange={this.onChange} value={this.state.orderby} required>
                                            <option value="">Select</option>
                                            <option value="random">Random</option>
                                            <option value="static">Static</option>
                                        </select>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Exam Date <span className="text-danger">*</span></Label>
                                        <Input type="date" name="examdate" id="examdate" onChange={this.onChange} value={this.state.examdate} required />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>From Time <span className="text-danger">*</span></Label>
                                        <Input type="time" name="fromtime" id="fromtime" onChange={this.onChange} value={this.state.fromtime} required />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>To Time <span className="text-danger">*</span></Label>
                                        <Input type="time" name="totime" id="totime" onChange={this.onChange} value={this.state.totime} required />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Reminder <span className="text-danger">*</span></Label>
                                        <select name="reminder" className="form-control" onChange={this.onChange} value={this.state.reminder} required>
                                            <option value="">Select</option>
                                            <option value="no-reminder">No-Reminder</option>
                                            <option value="sms">Sms</option>
                                            <option value="push">Push</option>
                                            <option value="sms & push">Sms & Push</option>
                                        </select> 
                                    </FormGroup>  
                                </Col>
                                <Col md={12}>
                                    <FormGroup>
                                        <Button type="submit" color="success" style={{float : 'right'}} disabled={this.state.btnEditText == 'Update' ? false : true}>{this.state.btnEditText}</Button>&emsp;
                                    </FormGroup>
                                </Col>
                            </Row>
                            </form>
                        </Collapse>
                        <Row style={{marginTop : '20px'}}>
                            <Col md="12">
                                <span style={{float : 'right'}}>Show <b>{this.state.data.length}</b> Records</span>
                                <Table responsive bordered >
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Exam Name</th>
                                            <th>Class</th>
                                            <th>Subject</th>
                                            <th>Question Id</th>
                                            <th>Mark per Question</th>
                                            <th>Total Mark</th>
                                            <th>Exam Time Limit</th>
                                            <th>Date</th>
                                            <th>Time</th>
                                            <th>Reminder Type</th>
                                            <th>Manage</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data.length > 0 ? renderTodos : <tr><td colSpan="12" align="center" style={{color : 'red',fontWeight : 'bold'}}>No data Found...</td></tr>}
                                    </tbody>
                                </Table>
                            </Col>
                            <Col md={12}>
                                <Pagination
                                    activePage={this.state.activePage}
                                    itemsCountPerPage={this.state.todosPerPage}
                                    pageRangeDisplayed={3}
                                    totalItemsCount={this.state.data.length}
                                    onChange={this.handlePageChange}
                                />
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                </Col>
            </Row>
        </div>
        </div>
	)
  }
}

export default ExamSetup;



// WEBPACK FOOTER //
// ./src/Questions/ExamSetup.js